import { Store } from '@ngrx/store';
import { IAppState } from '../appState/app.state';
import { Injectable, Inject } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AbstractSessionService } from './abstract-session.service';
import { AppState } from '../appState/appStateStore.module';

@Injectable()
export class SessionGuard implements CanActivate {

    constructor(private router: Router, private store: Store<AppState>,
      private sessionService: AbstractSessionService) { }

    canActivate() {
      let loggedIn = false;
      this.store.take(1).subscribe(s => loggedIn = s.app.session.loggedIn);

      if (!loggedIn) {
        this.sessionService.logout();
      }

      return loggedIn;
    }
}



// WEBPACK FOOTER //
// ./src/app/session/session.guard.ts